import React, { useState } from "react";
import EligibilityForm from "./EligibilityForm";
import LenderGrid from "./LenderGrid";
import "./eligibility.css";
import "./eligibilitymobile.css";

export default function EligibilityPage() {
  const [showMore, setShowMore] = useState(false);

  return (
    <main className="eligibility-page">
      <section className="eligibility-hero">
        <div className="cb-container eligibility-hero-inner">
          <span className="cb-section-label">Personal Loan</span>
          <h1 className="eligibility-hero-title">Check offers tailored to your profile</h1>
          <p className="eligibility-hero-lead">
            Compare estimates from partner banks and NBFCs in minutes. Final approval remains with the lender.
          </p>
        </div>
      </section>

      <section className="eligibility-main cb-container">
        <div className="info-section">
          <h2>Personal loan offers, compared clearly</h2>
          <p className="info-description">
            A personal loan helps with planned and unplanned needs. It is unsecured — no collateral required —
            and can be used for renovation, medical expenses, travel, and more
            {!showMore && (
              <button type="button" className="show-more-inline" onClick={() => setShowMore(true)}>
                Show more
              </button>
            )}
            {showMore && (
              <>
                . Lenders review income and credit profile against their criteria. Comparing eligible offers helps you
                shortlist a rate and tenure that fit your repayment capacity.
              </>
            )}
          </p>

          <div className="benefits-grid">
            <div className="benefit-card">
              <strong>Competitive rates</strong>
              <span>Estimates starting near 9.98%* depending on profile and lender</span>
            </div>
            <div className="benefit-card">
              <strong>Multi-lender compare</strong>
              <span>Review offers from 30+ banks and NBFCs in one place</span>
            </div>
            <div className="benefit-card">
              <strong>Single application path</strong>
              <span>Avoid scattering applications across every portal</span>
            </div>
          </div>
        </div>

        <div className="form-section">
          <div className="form-card">
            <div className="form-card-header">
              <h2>Check personal loan offers</h2>
              <p>Share basic details to see estimated eligibility.</p>
            </div>
            <EligibilityForm />
            <p className="form-disclaimer">
              By submitting this form, you agree to our{" "}
              <a href="https://www.corebankers.in/consent-policy">Consent Policy</a>,{" "}
              <a href="https://www.corebankers.in/terms">Terms of Use</a> &{" "}
              <a href="https://www.corebankers.in/privacy">Privacy Policy</a>.
            </p>
          </div>
        </div>
      </section>

      <section className="lender-section cb-container">
        <header className="lender-header">
          <span className="cb-section-label">Partners</span>
          <h2 className="lender-heading">Top lending partners</h2>
        </header>
        <LenderGrid />
      </section>
    </main>
  );
}
